module.exports = __webpack_public_path__ + "static/media/faq-sub-add-docs.3ab1244f.svg";